import Vue from 'vue'

export const state = {
  markdown: '',
  tickets: [],
  docs: [],
  code: [],
  ticketMarkdown: '',
  docMarkdown: '',
  codeMarkdown: '',
}

export const getters = {}

export const mutations = {
  setMarkdown(state, md) {
    state.markdown = md
  },
  clearLines(state, item) {
    state.tickets.splice(0, state.tickets.length)
    state.docs.splice(0, state.docs.length)
    state.code.splice(0, state.code.length)
  },
  addTicket(state, item) {
    state.tickets.push(item)
  },
  updateTicket(state, item) {
    Vue.set(state.tickets, item.index, item.value)
  },
  addDoc(state, item) {
    state.docs.push(item)
  },
  updateDoc(state, item) {
    Vue.set(state.docs, item.index, item.value)
  },
  addCode(state, item) {
    state.code.push(item)
  },
  updateCode(state, item) {
    Vue.set(state.code, item.index, item.value)
  },
  setTicketMarkdown(state, md) {
    state.ticketMarkdown = md
  },
  setDocMarkdown(state, md) {
    state.docMarkdown = md
  },
  setCodeMarkdown(state, md) {
    state.codeMarkdown = md
  },
  /**
   * Shifts the content markers up or down a row in response to
   * adding or removing a line of the markdown editor
   * @param state
   * @param payload
   */
  shiftContentMarkers(state, payload) {
    const row = payload.row
    const del = payload.del
    state.tickets.splice(row, del, true)
    state.docs.splice(row, del, true)
    state.code.splice(row, del, false)
  },
}

export const actions = {}
